<template>
    <div class="grid md:grid-cols-3 gap-8">
        <SubscriptionItem
                v-for="(campaign) in campaigns"
                :key="campaign.CampaignId"
                :campaign="campaign"
        ></SubscriptionItem>
    </div>
</template>
<script>
import ModalMixin from '@/mixin/ModalMixin';
//component
import SubscriptionItem from './SubscriptionItem.vue';
//service
import BKSubscription from "@/module/Subscription/List/service/BKSubscription";

/**
 * @event onLoaded
 */
export default {
    name: "SubscriptionList",
    mixins: [ModalMixin],
    components: {
        SubscriptionItem,
    },
    props: {
        // initListConfig:     { type: Object, required: true },
        // initFilterConfig:   { type: Object, required: true },
    },
    data: function() {
        return {
            listConfig: null,
            filterConfig: null,

            campaigns: [],

            isLoading: false,
            isLoaded: false,
            isHaveItem: false,
        };
    },
    created: function() {
        // this.listConfig = this.initListConfig;
        // this.filterConfig = this.initFilterConfig;

        this.getList();
    },
    methods: {
        reinitList: function(listConfig, listFilter) {
            this.listConfig = listConfig;
            this.filterConfig = listFilter;
            this.campaigns = [];
            this.getList();
        },
        getList: function() {
            return new Promise((resolve) => {
                this.isLoading = true;
                BKSubscription.apiGetSubscriptionList().subscribe({
                    next: (campaigns) => {
                        for (var campaign of campaigns) {
                            //TODO: Add GA Tracking.
                            this.campaigns.push(campaign);
                        }

                        console.log('campaigns', this.campaigns);


                        this.isLoading = false;
                        this.isLoaded = true;
                        this.isHaveItem = this.campaigns.length > 0
                            ? true
                            : false;

                        resolve();
                        this.$emit('onLoaded', this.isHaveItem);
                    },
                    error: (err) => {
                        this.isLoading = false;
                        this.isLoaded = true;
                        this.isHaveItem = false;
                        this.listConfig.isSeeMoreEnable = false;
                        this.errorApi(err);

                        this.$emit('onLoaded', this.isHaveItem);
                        resolve();
                    },
                });
            });
        },

        // loadMore: async function() {
        //     console.log('load more list', this.listConfig.isSeeMoreEnable);
        //     if (!this.listConfig.isSeeMoreEnable || this.isLoading) {
        //         return;
        //     }

        //     this.modal.loadingModal.show();
        //     await this.getList();
        //     this.modal.loadingModal.hide();
        // },
    },
}
</script>
<style lang="scss" scoped>
</style>
